import { Component, Input, OnInit } from '@angular/core';
import { Annotation } from '../../models/Annotation';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';
import { LoginService } from '../../services/Login.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Clipboard } from '@angular/cdk/clipboard';
import { constObj } from '../../Constants/constants';
import { HttpcallService } from '../../services/httpcall.service';
import { SessionService } from '../../services/Session.service';

@Component({
  selector: 'app-annotation-records',
  templateUrl: './annotation-records.component.html'
})
export class AnnotationRecordsComponent implements OnInit {

  constructor(private loginService: LoginService, private httpCallService: HttpcallService,
    public commonDataService: CommonDataService, private graphQlService: GraphqlService, private clipboard: Clipboard,
    public dialog: MatDialog, private sessionService: SessionService) {
  }

  @Input() paragraphId: string = "";
  @Input() lineBool: string = "";
  @Input() paraNum: string = "";
  shareLinkLabel: string;
  editLinkLabel: string;
  deleteLinkLabel: string;
  addedTextLabel: string;
  emailId: string = "";
  annotationContent: Annotation[] = [];
  globalinfodata;
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getEmailId();
    this.globalinfodata = this.sessionService.globallablesinfo;
    
    if (this.globalinfodata != null) {
      this.filterlabels(this.globalinfodata)
    } else {
      this.getYourAnnotationLabel();
    }

    this.commonDataService.updateAnnotationParagraphId.subscribe(data => {
      if (data == this.paragraphId) {
        this.getEmailId();
      }
    })
    this.commonDataService.addAnnotationParagraphId.subscribe(data => {
      if (data == this.paragraphId) {
        this.getEmailId();
      }
    })
    this.commonDataService.removeAnnotationFromArray.subscribe(id => {
      this.annotationContent = this.annotationContent.filter(x => x.id != id);
    });
  }
  filterlabels(data) {
    var labels = data.content.data.labels;
    labels = labels.filter(x => x.key.trim());
    this.shareLinkLabel = labels.filter(x => x.key == "global_share").map(y => y.value);
    this.editLinkLabel = labels.filter(x => x.key == "global_edit").map(y => y.value);
    this.deleteLinkLabel = labels.filter(x => x.key == "global_delete").map(y => y.value);
    this.addedTextLabel = labels.filter(x => x.key == "global_added").map(y => y.value);

  }

  getYourAnnotationLabel() {
    if (this.sessionService.globallablesinfo == null || this.sessionService.globallablesinfo == undefined) {
      this.graphQlService.getGlobalLabels().subscribe(data => {
        if (data != "") {
          this.sessionService.assignglobalinfo(data);
          this.filterlabels(data)
        }
      });
    }
    else {
      this.filterlabels(this.sessionService.globallablesinfo);
    }
  }

  getAnnotation() {
    this.httpCallService.getAnnotation(this.paragraphId, "false").subscribe((resp: any) => {
      this.annotationContent = resp;
      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  getEmailId() {
    if (this.sessionService.userInfo == undefined || this.sessionService.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.commonDataService.emailId.next(data.user.email);
        this.emailId = data.user.email;
        this.getAnnotation();
        this.sessionService.assignUserInfo(data.user);
      })
    }
    else {
      this.emailId = this.sessionService.userInfo.user.email;
      this.getAnnotation();
    }
  }

  editAnnotation(annotation: Annotation) {
    if (this.lineBool) {
      this.commonDataService.annotationUpdateSource.next("AnnotationWithinContent");
      this.commonDataService.showRightPanel.next(true);
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.commonDataService.annotationContent.next(annotation);
      this.commonDataService.rightOverlayOption.next("Add Annotation");
    }
    else {
      this.commonDataService.annotationUpdateSource.next("Your Annotation");
      this.commonDataService.annotationContent.next(annotation);
      this.commonDataService.rightOverlayOption.next("Add Annotation");
    }
  }

  deleteAnnotation(annotation: Annotation) {
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: constObj.annotationDeletionConfirmationPromptMessage
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commonDataService.isConfirmationPopUpOpen.next(false);
        this.commonDataService.showLoader.next(true);
        var deleteAnnotation: Annotation = {
          id: annotation.id, topicId: annotation.topicId, paragraphId: annotation.paragraphId, annotationTitle: annotation.annotationTitle,
          annotationDescription: annotation.annotationDescription, 
          application: "", createdOn: annotation.createdOn, modifiedOn: "", breadCrumb: annotation.breadCrumb, isDeleted: true, annotationsURL: annotation.annotationsURL, area: annotation.area, navigationPath: annotation.navigationPath
        }
        this.httpCall(deleteAnnotation);
        this.commonDataService.deleteAnnotation.next(this.paragraphId);
      }
    });
  }

  httpCall(annotation: Annotation) {
    this.httpCallService.addUpdateAnnotation(annotation).toPromise()
      .then(response => {
        if (response == "Annotation added successfully.") {
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.annotationRemovedSuccessMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.commonDataService.deleteAnnotationParagraphId.next(annotation.paragraphId);
          this.commonDataService.removeAnnotationFromArray.next(annotation.id);
          this.commonDataService.showLoader.next(false);
        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.annotationRemovedFailMessage
          }
          this.commonDataService.notificationObject.next(obj);
        }
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }


  copyToClipboard(annotation: Annotation) {
    const Regex = /(\~)/g;
    let cbreadCrumb = annotation.breadCrumb.replace(Regex, ' -> ')
    if ((!annotation.annotationsURL?.startsWith("/") && annotation.annotationsURL?.split("/").length < 3) || (annotation.annotationsURL.startsWith("/") && annotation.annotationsURL.split("/").length <= 3)){
      annotation.annotationsURL="/"+annotation.annotationsURL.split("/")[1]+"/"+annotation.annotationsURL.split("/")[2]+"/"+this.paraNum;
    }
    this.clipboard.copy("Annotation: " + annotation.annotationDescription + "\nLink: " + location.origin + annotation.annotationsURL + "\nLocation: " + cbreadCrumb );
    let obj = {
      type: 'success',
      displayTime: 5000,
      position: 'bottom',
      message: constObj.linkSharedMessage
    }
    this.commonDataService.notificationObject.next(obj);
  }
}
